import {ref, unRef, shallowRef, computed, onMounted} from 'vue'
import {_get, CRUISE_SVG_BASE} from '@/actions.js'
import {make_headPhotos} from './photos.js'


export default function useShip({ship}) {

    let {id, name, is_sea, star, company, dataInf } = ship

    const shipId = id.toString()
    const typeName = dataInf.typeName || 'Теплоход'
    const fullName = `${typeName} «${name}»`


    const getsimple = (field) => {
        return _get(dataInf, field)
    }

    const hasAttr = d => {
        return d.name && d.src
    }

    const ship_link = {
        name: 'Ship', 
        query: {
            id: shipId,
        }
    }


    let {captain, cruise_director,  restaurant_director } = ship
    captain.is = hasAttr(captain)
    cruise_director.is = hasAttr(cruise_director)
    restaurant_director.is = hasAttr(restaurant_director)


    let photo
    let src = getsimple('files.photo.path')
    if (src) {
        photo = {src, id: getsimple('files.photo.name')}
    } else {
        photo = ship.photo // берем наше только если нет инфофлотовского. Наши не замененные
        photo.id = shipId
    }

    const photoMain = photo

    let pho = photo
    pho = [photo].concat( getsimple('photos') || [] )

    const photos = make_headPhotos(  pho, photo, {useTitle:true} )

    const htmlblock = (ob, name, dop ) => {
        let html = ob && ob[name] ? ob[name] : ''
        let has = html ? true : false
        let link = dop.link ??  'all' // all pdf none - какие ссылки оставлять
        let orig = dop.orig ?? false // orig - не менять, для отладки
        let ship = dop.ship ?? false
        let ret = {
            has,
            html,
            link,
            orig,
            ship,
        }
        return ret
    }


    const descriptionBig = htmlblock( dataInf, 'descriptionBig', { link: 'pdf', ship:true})
    

    const video = getsimple('video') || ''
//    const excursions = getsimple('include') || ''
    const excursions = htmlblock( dataInf, 'include', { link: 'pdf'})


    let {decks_num, cabins_num, capacity, construction_year, renovation_year, length, width, draught } = ship
    

    return {
        shipName: name, shipStar: star, shipCompany: company,
        shipId, name, is_sea, fullName, ship_link,
        captain, cruise_director,  restaurant_director,
        photoMain, descriptionBig, photos, 
        video, excursions,
        decks_num, cabins_num, capacity, construction_year, renovation_year, length, width, draught,
    }
}
